import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SrgVerdictParagraph,
    StaticLinkWrapper,
    SrgParagraph,
    SrgQuestionnaireButton,
} from 'src/domains/players/state/srgQuestionnaire/SrgQuestionnaire.style';

import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { SrgVerdictFailedSecondaryPropsType } from 'src/domains/players/state/srgQuestionnaire/SrgVerdict';

export const SrgVerdictFailedSecondary = observer(
    'SrgVerdictFailedSecondary',
    ({ accountHelperMail, handleCloseModal }: SrgVerdictFailedSecondaryPropsType): JSX.Element | null => {
        return (
            <SrgVerdictParagraph data-test='srg-verdict-secondary-paragraph'>
                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part1'
                        defaultText='It looks like you need some support to keep your gambling safe, so we’ve temporarily restricted you from placing bets or making deposits. Please email us on {accountHelperMail} with the subject line ‘Safe Gambling Questionnaire’ and we’ll let you know what we can do to help you.'
                        params={{ accountHelperMail }}
                    />
                </SrgParagraph>

                <SrgQuestionnaireButton
                    size='large'
                    onClick={handleCloseModal}
                    dataTest='close-button'
                >
                    Ok, I understand
                </SrgQuestionnaireButton>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part2'
                        defaultText='We’d like to remind you again about the organisations that can offer you independent help and advice.'
                    />
                </SrgParagraph>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part3'
                        defaultText='GambleAware provides free advice, tools, and support to keep people safe from gambling harm. They can be contacted on 0808 8020 133 or you can visit their website at '
                    />
                    <StaticLinkWrapper
                        isUnderlined={true}
                        to='https://www.gambleaware.org'
                    >
                        www.gambleaware.org
                    </StaticLinkWrapper>
                </SrgParagraph>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part4'
                        defaultText='GamCare provides counselling, advice and practical help in addressing the social impact of gambling in the UK. You can live chat with a member of their team on their website '
                    />
                    <StaticLinkWrapper
                        isUnderlined={true}
                        to='https://www.gamcare.org.uk'
                    >
                        www.gamcare.org.uk.
                    </StaticLinkWrapper>
                </SrgParagraph>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part5'
                        defaultText='Gamstop lets you put controls in place to restrict your online gambling activities. You can use this service to prevent yourself from using gambling websites and apps run by companies licensed in Great Britain, for a period of your choosing '
                    />
                    <StaticLinkWrapper
                        isUnderlined={true}
                        to='https://www.gamstop.co.uk'
                    >
                        www.gamstop.co.uk.
                    </StaticLinkWrapper>
                </SrgParagraph>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part6'
                        defaultText='Gordon Moody is the leading provider of gambling therapy services in the UK offering healing and hope for individuals, families and communities affected by gambling related harm. Gordon Moody delivers a range of services from residential treatment to online support. You can find more information at '
                    />
                    <StaticLinkWrapper
                        isUnderlined={true}
                        to='www.gamblingtherapy.org'
                    >
                        www.gamblingtherapy.org.
                    </StaticLinkWrapper>
                </SrgParagraph>

                <SrgParagraph>
                    <I18n
                        langKey='srg.verdict.secondary.fail.part7'
                        defaultText="If you have any questions or ever feel like your gambling's not fun anymore, please contact us on {accountHelperMail} and one of our trained team will be happy to help you."
                        params={{ accountHelperMail }}
                    />
                </SrgParagraph>
            </SrgVerdictParagraph>
        );
    }
);
